import {uniqueId} from 'lodash'

const columns = [
  {
    title: 'Date',
    prop: 'timeOfGetMessage',
    type: 'date',
    width: 'minmax(100px, 1fr)'
  },
  {
    title: 'User',
    prop: 'user.username',
    width: 'minmax(150px, 1.5fr)',
    capitalize: true
  },
  {
    title: 'Email from',
    prop: 'deliveryFromValue',
    width: 'minmax(150px, 1.5fr)'
  },
  {
    title: 'Received at',
    prop: 'timeOfGetMessage',
    type: 'date',
    formatDate: 'hh:mm:ss a',
    width: 'minmax(100px, 1fr)'
  },
  {
    title: 'Exclusion reason',
    prop: 'excludedReason.title'
  }
]

const prefix = 'email_stats_exclude_column_'
const emailStatsExcludeTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export default emailStatsExcludeTableColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/emailStatsExcludeTable.js